import React, { useCallback, useMemo, useState } from 'react'
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import Tooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import styles from "../styles.module.scss";
import ServerDataGrid from "views/pages/manage/common/data-grid/ServerDataGrid";
import { useWizard } from 'components/wizard/WizardContext';
import { getFormattedTime } from 'modules/studentRefund/common/services';
import { getDuration } from '../helper';
import { useHistory } from 'react-router-dom';
import moment from 'moment';


const ListComponent = ({
    rows,
    rowCount,
    nextButtonHandler = () => { },
    paginationInfo,
    currentPage = 0,
    currPageSize,
}) => {
    const history = useHistory();

    const openInNewTab = useCallback((url) => {
        window
            .open(window.location.origin + "/#/admin/" + url, "_blank")
            .focus();
    }, []);

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const { values, updateValues, dropdowns, next } = useWizard();

    const pagination = {
        page: (paginationInfo?.currPageNo ?? 0) + 1,
        pageSize: paginationInfo?.currPageSize || 10,
        total: paginationInfo?.totalRecords || 0,
        totalPages: paginationInfo?.totalPage || 0,
    };


    const admissionAdvisorColumns = useMemo(
        () => [
            {
                key: "psid",
                label: "PSID",
                sortable: true,
                width: 130,
                pinned: true,
                render: (value) =>
                    value ? (
                        <a
                            href="#"
                            className="text-primary text-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(`/#/admin/edp/studentDetails/${value}`, "_blank")
                            }}
                        >
                            {value}
                        </a>
                    ) : (
                        <span>-</span>
                    )
            },
            {
                key: "admissionSource",
                label: "Admission Source",
                sortable: true,
                width: 160,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "applicationId",
                label: "Application id",
                sortable: true,
                width: 160,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "studentName",
                label: "Student Name",
                sortable: true,
                width: 160,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "programAction",
                label: "Program Action",
                sortable: true,
                width: 160,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "totalRealisedAmount",
                label: "Total Realised Fee",
                sortable: true,
                width: 180,
                align: "right",
                render: (value) =>
                    value >= 0 ? (
                        <Tooltip title={formattedPrice(value)}>
                            <div className={styles["amount"]}>
                                {formattedPrice(value)}
                            </div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "termDispVal",
                label: "Term",
                sortable: true,
                width: 120,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "businessAreaDispVal",
                label: "BU",
                sortable: true,
                width: 140,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "academicGroupDispValue",
                label: "Stream",
                sortable: true,
                width: 140,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "courseId",
                label: "Course Id",
                sortable: true,
                width: 140,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "courseDescription",
                label: "Course Description",
                sortable: true,
                width: 200,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "courseAttribute",
                label: "Attribute",
                sortable: true,
                width: 160,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "courseAttributeValue",
                label: "Attribute Value",
                sortable: true,
                width: 180,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "costCenter",
                label: "Cost Center",
                sortable: true,
                pinned: true,
                width: 150,
                render: (value) =>
                    value ? (
                        <Tooltip title={value}>
                            <div className="ellipsis-text-container">{value}</div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
            {
                key: "amount",
                label: "Payment Amount",
                sortable: true,
                width: 160,
                pinned: true,
                align: "right",
                render: (value) =>
                    value >= 0 ? (
                        <Tooltip title={formattedPrice(value)}>
                            <div className={styles["amount"]}>
                                {formattedPrice(value)}
                            </div>
                        </Tooltip>
                    ) : (
                        <div>-</div>
                    ),
            },
        ],
        [openInNewTab]
    );

    const InvigilatorColumns = useMemo(() => [
        {
            key: "testName",
            label: "Test id",
            sortable: true,
            width: 160,
            pinned: true,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "testDesc",
            label: "Description",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "termDispValue",
            label: "Term",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "businessAreaDispValue",
            label: "BU",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "academicGroupDispValue",
            label: "Stream",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "examDate",
            label: "Exam Date",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={moment(value).format('DD/MM/YYYY')}>
                        <div className="ellipsis-text-container">{moment(value).format('DD/MM/YYYY')}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
         {
            key: "roomId",
            label: "Room no.",
            sortable: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "startTime",
            label: "Test timing",
            sortable: true,
            width: 160,
            render: (value, row) =>
                value ? (
                    <Tooltip title={`${getFormattedTime(value)} to ${getFormattedTime(row?.endTime)}`}>
                        <div className="ellipsis-text-container">{getFormattedTime(value)} to {getFormattedTime(row?.endTime)}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "startTime",
            label: "Test duration",
            sortable: true,
            width: 160,
            render: (value, row) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{getDuration(value, row?.endTime)}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "amount",
            label: "Payment Amount",
            sortable: true,
            pinned: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={formattedPrice(value)}>
                        <div className={styles["amount"]}>
                            {formattedPrice(value)}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
        {
            key: "costCenter",
            label: "Cost Center",
            sortable: true,
            pinned: true,
            width: 160,
            render: (value) =>
                value ? (
                    <Tooltip title={value}>
                        <div className="ellipsis-text-container">{value}</div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                ),
        },
    ], [openInNewTab])

    const columns = useMemo(() => {
        if (values?.vendorType === "INVIGILATOR") return InvigilatorColumns;
        if (values?.vendorType === "ADMISSION_ADVISOR") return admissionAdvisorColumns;
        return [];
    }, [values?.vendorType, InvigilatorColumns, admissionAdvisorColumns]);


    return (
        <div >
            <ServerDataGrid
                rows={rows || []}
                loading={false}
                columns={columns}
                rowKey="id"
                pagination={pagination}
                onPageChange={(p) => nextButtonHandler(p - 1, pagination.pageSize)}
                onPageSizeChange={(s) => nextButtonHandler(0, s)}
                sortConfig={sortConfig}
                onSortChange={(key, direction) => setSortConfig({ key, direction })}
            />
        </div>
    )
}

export default ListComponent;